import { useMemo } from "react";
export function useSpringPageable(options) {
    const { pageIndex, pageSize, sortField, sortDirection, } = options;
    return useMemo(() => ({
        size: pageSize !== null && pageSize !== void 0 ? pageSize : 10,
        sort: sortField ? [`${sortField},${sortDirection || "asc"}`] : undefined,
        page: pageIndex !== null && pageIndex !== void 0 ? pageIndex : 0,
    }), [pageIndex, pageSize, sortField, sortDirection]);
}
//# sourceMappingURL=useSpringPageable.js.map